const videoPlayers = document.querySelectorAll('.custom-video-wrapper');

if (videoPlayers) {
	function markVideoPlayerFocused(e) {
		e.target.classList.add('has-focused');
		e.target.removeEventListener('mouseenter', markVideoPlayerFocused);
		e.target.removeEventListener('focusin', markVideoPlayerFocused);
	}
	for (let i = 0; i < videoPlayers.length; i++) {
		videoPlayers[i].addEventListener('mouseenter', markVideoPlayerFocused);
		videoPlayers[i].addEventListener('focusin', markVideoPlayerFocused);
	}
}
